<template>
  <section id="para-quem" class="dual-section" data-theme="split">
    <div class="dual-grid">
      <article class="panel panel-pros" data-reveal>
        <header class="panel-head">
          <div class="panel-tag panel-tag-pros">
            <i class="fas fa-crosshairs" aria-hidden="true"></i>
            Para quem é
          </div>
        </header>

        <ul class="list list-pros">
          <li
            v-for="(item, index) in pros"
            :key="item"
            :class="{ 'is-climax': index === pros.length - 1 }"
          >
            <span class="li-icon" aria-hidden="true">
              <i :class="index === pros.length - 1 ? 'fas fa-check-double' : 'fas fa-check'"></i>
            </span>
            <span class="li-text" v-html="item"></span>
          </li>
        </ul>
      </article>

      <article class="panel panel-cons" data-reveal>
        <header class="panel-head">
          <div class="panel-tag panel-tag-cons">
            <i class="fas fa-ban" aria-hidden="true"></i>
            Para quem não é
          </div>
        </header>

        <ul class="list list-cons">
          <li v-for="item in cons" :key="item">
            <span class="li-icon" aria-hidden="true">
              <i class="fas fa-times"></i>
            </span>
            <span class="li-text">{{ item }}</span>
          </li>
        </ul>
      </article>
    </div>
  </section>
</template>

<script setup>
const pros = [
  'Para quem sempre sente que chega atrasado.',
  'Para quem sabe que há manipulação, mas não sabe decodificar.',
  'Para quem cansou de seguir recomendações iguais e quer pensar por conta própria.',
  'Para quem busca clareza, direção e leitura verdadeira.',
  'Para quem quer evoluir de forma séria, simples e estratégica.',
  '<strong>Para quem quer aprender o processo de verdade — não seguir sinal solto.</strong>',
];

const cons = [
  'Para quem procura fórmula mágica sem fundamento.',
  'Para quem não aceita responsabilidade sobre suas decisões.',
  'Para quem busca emoção, não estratégia.',
  'Para quem prefere hype à visão.',
  'Para quem não está disposto a aprender de verdade.',
];
</script>

<style scoped>
.dual-section {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0;
  padding: 0 !important;
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif;
}

.dual-section,
.dual-section * {
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;
}

.dual-section::before {
  display: none !important;
}

.dual-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 16px;
  align-items: stretch;
}

.panel {
  position: relative;
  border-radius: 16px;
  padding: 18px 18px 20px;
  overflow: hidden;
  box-shadow: 0 14px 38px rgba(0, 0, 0, 0.28);
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;
}

.panel::before {
  content: '';
  position: absolute;
  inset: 0 12px auto;
  height: 2px;
  border-radius: 999px;
  opacity: 0.95;
}

.panel::after {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.4;
}

.panel-pros {
  border: 1px solid rgba(96, 190, 160, 0.24);
  background:
    radial-gradient(circle at 14% 8%, rgba(56, 211, 159, 0.09), transparent 44%),
    linear-gradient(165deg, rgba(13, 20, 32, 0.97), rgba(9, 13, 24, 0.95));
}

.panel-pros::before {
  background: linear-gradient(
    90deg,
    rgba(78, 115, 223, 0),
    rgba(110, 146, 238, 0.88) 24%,
    rgba(88, 224, 176, 0.9) 76%,
    rgba(88, 224, 176, 0)
  );
  box-shadow: 0 0 14px rgba(96, 210, 180, 0.26);
}

.panel-pros::after {
  background: radial-gradient(circle at 18% 10%, rgba(78, 115, 223, 0.18), transparent 52%);
}

.panel-cons {
  border: 1px solid rgba(255, 124, 143, 0.16);
  background:
    radial-gradient(circle at 86% 8%, rgba(255, 124, 143, 0.06), transparent 46%),
    linear-gradient(165deg, rgba(15, 13, 20, 0.97), rgba(11, 9, 16, 0.95));
}

.panel-cons::before {
  background: linear-gradient(
    90deg,
    rgba(255, 124, 143, 0),
    rgba(255, 124, 143, 0.66) 26%,
    rgba(155, 89, 182, 0.7) 76%,
    rgba(155, 89, 182, 0)
  );
  box-shadow: 0 0 14px rgba(255, 124, 143, 0.18);
}

.panel-cons::after {
  background: radial-gradient(circle at 82% 8%, rgba(155, 89, 182, 0.12), transparent 56%);
}

.panel-head,
.list {
  position: relative;
  z-index: 2;
}

.panel-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
  padding: 0;
  background: transparent !important;
  box-shadow: none !important;
  border: 0 !important;
}

.panel-head::after {
  content: '';
  flex: 1;
  height: 1px;
  opacity: 0.5;
}

.panel-tag {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  width: fit-content;
  margin: 0;
  padding: 5px 11px 5px 10px;
  border-radius: 2px 10px 2px 10px;
  font-family: var(--landing-font-mono) !important;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  line-height: 1.1;
}

.panel-tag i {
  font-family: 'Font Awesome 5 Free' !important;
  font-weight: 900;
  font-size: 10px;
}

.panel-tag-pros {
  color: #bfe9d8;
  border: 1px solid rgba(56, 211, 159, 0.3);
  border-left: 2px solid rgba(56, 211, 159, 0.9);
  background: linear-gradient(90deg, rgba(56, 211, 159, 0.13), rgba(56, 211, 159, 0.02));
}

.panel-tag-pros i {
  color: #5fe8b4;
}

.panel-tag-cons {
  color: #ffc4cd;
  border: 1px solid rgba(255, 124, 143, 0.28);
  border-left: 2px solid rgba(255, 124, 143, 0.85);
  background: linear-gradient(90deg, rgba(255, 124, 143, 0.11), rgba(255, 124, 143, 0.02));
}

.panel-tag-cons i {
  color: #ff93a4;
}

.panel-pros .panel-head::after {
  background: linear-gradient(90deg, rgba(96, 210, 180, 0.5), rgba(96, 210, 180, 0.06));
}

.panel-cons .panel-head::after {
  background: linear-gradient(90deg, rgba(255, 124, 143, 0.42), rgba(255, 124, 143, 0.05));
}

.list {
  list-style: none;
  margin: 0;
  padding-left: 0;
  display: grid;
  gap: 8px;
}

.list li {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  padding: 9px 12px;
  border-radius: 2px 12px 2px 12px;
  border: 1px solid rgba(255, 255, 255, 0.04);
  background: linear-gradient(120deg, rgba(255, 255, 255, 0.025), rgba(255, 255, 255, 0.008));
  line-height: 1.45;
  color: #e2e9f7;
  font-size: clamp(1.04rem, 1.15vw, 1.18rem);
  font-weight: 500;
  letter-spacing: 0.004em;
  transition: transform 0.18s ease, border-color 0.18s ease, background 0.18s ease;
}

.list-pros li:hover {
  transform: translateX(4px);
  border-color: rgba(56, 211, 159, 0.28);
  background: linear-gradient(120deg, rgba(56, 211, 159, 0.08), rgba(255, 255, 255, 0.01));
}

.list-cons li {
  color: #c3c9da;
  font-weight: 450;
}

.list-cons li:hover {
  transform: translateX(4px);
  border-color: rgba(255, 124, 143, 0.24);
  background: linear-gradient(120deg, rgba(255, 124, 143, 0.06), rgba(255, 255, 255, 0.01));
}

.li-icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-top: calc((1.45em - 22px) / 2);
  border-radius: 2px 8px 2px 8px;
}

.li-icon i {
  font-family: 'Font Awesome 5 Free' !important;
  font-weight: 900;
  font-size: 10px;
  line-height: 1;
}

.list-pros .li-icon {
  border: 1px solid rgba(56, 211, 159, 0.3);
  background: rgba(56, 211, 159, 0.1);
  color: #5fe8b4;
}

.list-cons .li-icon {
  border: 1px solid rgba(255, 124, 143, 0.26);
  background: rgba(255, 124, 143, 0.08);
  color: #ff93a4;
}

.li-text {
  flex: 1;
  min-width: 0;
}

.list-pros li.is-climax {
  border-color: rgba(122, 162, 255, 0.36);
  background: linear-gradient(120deg, rgba(78, 115, 223, 0.16), rgba(155, 89, 182, 0.1));
  box-shadow: 0 0 22px rgba(115, 148, 240, 0.14);
}

.list-pros li.is-climax:hover {
  border-color: rgba(150, 182, 255, 0.5);
  background: linear-gradient(120deg, rgba(78, 115, 223, 0.2), rgba(155, 89, 182, 0.14));
}

.list-pros li.is-climax .li-icon {
  border-color: rgba(140, 175, 255, 0.4);
  background: rgba(122, 162, 255, 0.14);
  color: #a8c4ff;
}

.list strong {
  color: #edf3ff;
  font-weight: 800;
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;
}

.list-pros li.is-climax .li-text {
  font-style: italic;
}

@media (max-width: 767px) {
  .dual-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .panel {
    padding: 14px 14px 16px;
    border-radius: 14px;
  }

  .list li {
    font-size: 1rem;
    line-height: 1.38;
  }
}
</style>
